import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import File from 'views/pages/File'
import ProgressiveButton from 'views/pages/ProgressiveButton'
import CustomModal from 'views/pages/CustomModal'
import { Input, ModalBody, ModalFooter } from 'reactstrap'
import { setHomeworkTitle, uploadHomework } from 'store/Library/actions'

const UploadHomework = (props) => {
  const location = useLocation()

  const driveFolder =
    location.state && location.state.folderId ? location.state.folderId : null

  let language = props.language || {}
  const dispatch = useDispatch()
  return (
    <CustomModal backPath={`/library`} title={'Upload file'} size='lg'>
      <ModalBody className='scrollbar'>
        <form
          id='add-homework'
          onSubmit={(event) => dispatch(uploadHomework(event, driveFolder))}
        >
          <div className='row'>
            <div className='col-12'>
              <Input
                type='text'
                placeholder={'File title'}
                value={props.library.homeworkTitle}
                onChange={(e) => dispatch(setHomeworkTitle(e))}
              />
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-12'>
              <File
                language={language}
                placeholder={
                  language.general ? language.general.choose_file : null
                }
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <File
                placeholder={
                  language.my_library
                    ? language.my_library.choose_thumbnail
                    : null
                }
              />
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter className='py-3 border-top'>
        <ProgressiveButton
          percent={props.library.libraryUploadPercent}
          status={props.library.fileUploadStatus}
          placeholder={language.general ? language.general.submit : null}
          language={props.language}
          form='add-homework'
          type='submit'
        />
        <Link to='/library' className='btn py-2 btn-transparent active-link'>
          {language.general ? language.general.cancel : null}
        </Link>
      </ModalFooter>
    </CustomModal>
  )
}

export default UploadHomework
